module.exports = __webpack_public_path__ + "static/Octave-a2cb9ebd761bb4eb934df0478fe24359.jpg";